import React from "react";

const PdfTabel = ({ product }) => {
  const formatNumber = (value) => {
    let num = parseFloat(value);
    if (isNaN(num)) return "";
    return num.toLocaleString("en-US");
  };
  return (
    <div className="table-container">
      <table>
        <thead>
          <tr>
            <th rowSpan="2" style={{border: "1px solid grey"}}>S.No.</th>
            <th  rowSpan="2"style={{border: "1px solid grey",  fontFamily: '"Arial", sans-serif' }}>
              Item & Description
            </th>
            <th  rowSpan="2" style={{border: "1px solid grey"}}>HSN/SAC</th>
            <th  rowSpan="2" style={{border: "1px solid grey"}}>Qty</th>
            <th rowSpan="2" style={{border: "1px solid grey"}}>Rate</th>
            <th  colSpan="2" style={{border: "1px solid grey"}}>CGST</th>
            <th   colSpan="2" style={{border: "1px solid grey"}}>SGST</th>
            <th  rowSpan="2" style={{border: "1px solid grey"}}>Amount</th>
          </tr>
          <tr>
            <th style={{border: "1px solid grey"}}>%</th>
            <th style={{border: "1px solid grey"}}>Amt</th>
            <th style={{border: "1px solid grey"}}>%</th>
            <th style={{border: "1px solid grey"}}>Amt</th>
          </tr>
        </thead>
        <tbody>
          {product?.map((item, index) => (
            <tr key={item.id}>
              <td style={{border: "1px solid grey", fontWeight: "200px"}}>{index + 1}</td>
              <td style={{border: "1px solid grey"}}>{item?.productName}<br></br>{item?.description}</td>
              <td style={{border: "1px solid grey"}}>{item?.HSNNumber || "-"}</td>
              <td style={{border: "1px solid grey"}}>{item.quantity}</td>
              <td style={{border: "1px solid grey"}}> {formatNumber(item.rate)}</td>
              <td style={{border: "1px solid grey"}}>{formatNumber(item.cgstTax)} %</td>
              <td style={{border: "1px solid grey"}}> {formatNumber(item.cgstTaxamount)}</td>
              <td style={{border: "1px solid grey"}}>{formatNumber(item.sgstTax)} %</td>
              <td style={{border: "1px solid grey"}}> {formatNumber(item.sgstTaxamount)}</td>
              <td style={{border: "1px solid grey"}}> {formatNumber(item.totalproductamount)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PdfTabel;
